import React from 'react'
import { Helmet } from "react-helmet-async";
const ContactUs = () => {
  return (
    <>
      <Helmet>
        {/* Primary SEO */}
        <title>
          Contact Us | Get in Touch with Affsoft IT Solutions Pvt. Ltd.
        </title>

        <meta
          name="title"
          content="Contact Us | Get in Touch with Affsoft IT Solutions Pvt. Ltd."
        />

        <meta
          name="description"
          content="Contact Affsoft IT Solutions Pvt. Ltd. for ERP consulting, NetSuite implementation, cloud solutions, software development, digital transformation, and enterprise IT services. Reach out to our experts for business inquiries, support, or project consultations."
        />

        <meta
          name="keywords"
          content="Contact Affsoft, Contact Us, Affsoft IT Solutions, ERP Consulting, NetSuite Consulting, Software Development Company, Enterprise IT Services, Digital Transformation, Cloud Solutions, IT Consulting, Business Inquiries, Technical Support, Get in Touch, Affsoft Office, Contact Information, Affsoft IT Solutions Pvt. Ltd."
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Affsoft IT Solutions Pvt. Ltd." />
        <meta name="language" content="English" />
        <meta name="theme-color" content="#0d5c53" />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://www.affsoft.com/contact-us"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta
          property="og:site_name"
          content="Affsoft IT Solutions Pvt. Ltd."
        />
        <meta
          property="og:title"
          content="Contact Us | Affsoft IT Solutions Pvt. Ltd."
        />
        <meta
          property="og:description"
          content="Have questions or need expert IT solutions? Contact Affsoft IT Solutions Pvt. Ltd. for ERP implementation, NetSuite consulting, software development, cloud services, and digital transformation solutions."
        />
        <meta
          property="og:url"
          content="https://www.affsoft.com/contact-us"
        />
        <meta
          property="og:image"
          content="https://www.affsoft.com/images/affsoft-logo.png"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Contact Us | Affsoft IT Solutions Pvt. Ltd."
        />
        <meta
          name="twitter:description"
          content="Connect with Affsoft IT Solutions for ERP consulting, software development, cloud solutions, enterprise applications, and digital transformation services. We're here to help your business grow."
        />
        <meta
          name="twitter:image"
          content="https://www.affsoft.com/images/affsoft-logo.png"
        />
      </Helmet>
      <div>

        <div
          className="hero-container container-fluid d-flex align-items-center justify-content-center position-relative overflow-hidden"
          style={{
            backgroundImage: "url('./images/home.jpg')",
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: '85vh',
            backgroundColor: '#0a1916' // dark operational environment fallback
          }}
        >
          {/* Background Grid Lines */}
          <div className="grid-overlay position-absolute top-0 start-0 w-100 h-100" style={{ opacity: 0.15 }}>
            <div className="grid-line line-v-1"></div>
            <div className="grid-line line-v-2"></div>
            <div className="grid-line line-v-3"></div>
          </div>

          {/* Infinite Slow-Scrolling Marquee Text Background Wrapper */}
          <div className="marquee-wrapper select-none position-absolute w-100 scroll-anim-fade-in" style={{ top: '15%', opacity: 0.05 }}>

          </div>

          <div className="marquee-wrapper select-none position-absolute w-100 scroll-anim-fade-in">
            <div className="marquee-content text-white">
              <span>Contact &nbsp;  </span>
              <span>Us  </span>
            </div>
          </div>

          {/* Main Content Layout */}
          <div className="container position-relative z-3 my-5">
            <div className="row align-items-center py-4">

              {/* Left Side Info */}
              <div className="col-12 col-md-5 text-start d-flex flex-column align-items-start hero-left-pane text-white mb-4 mb-md-0 scroll-anim-fade-in-left">
                <div className="asterisk-icon mb-3 text-success fs-3">✳</div>
                <h1 className="fw-bold mb-3 display-5"> Contact Us  </h1>
                <p className="tagline mb-4 text-white" style={{ fontSize: '1rem', lineHeight: '1.6', opacity: 0.9 }}>
                  Get in touch with our team of technical experts and digital strategists. Whether you are looking to scale your enterprise systems, build custom mobile applications, or embark on a digital transformation journey, we are here to help you accelerate growth.
                </p>
                <button className="btn btn-outline-light d-flex align-items-center gap-2 px-4 py-2 rounded-pill fw-semibold">
                  <span>➔</span>
                  <span>About High Tech Solutions</span>
                </button>
              </div>



            </div>
          </div>
        </div>
        <section className="contact-section py-5">
          <div className="container">
            <div className="row align-items-center gy-5">

              {/* Left Content */}
              <div className="col-lg-5">
                <div className="contact-tag d-flex align-items-center mb-4">
                  <span className="dot"></span>
                  <span className="ms-3">CONTACT US</span>
                  <span className="line mx-3"></span>
                  <span className="arrow">&#8594;</span>
                </div>

                <h1 className="contact-title">
                  Let's Make <br />
                  Your Brand <br />
                  Brilliant!
                </h1>
              </div>

              {/* Right Form */}
              <div className="col-lg-7">
                <form>

                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <label className="form-label">
                        Full name<span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control custom-input"
                      />
                    </div>

                    <div className="col-md-6 mb-4">
                      <label className="form-label">
                        Email address<span>*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control custom-input"
                      />
                    </div>
                  </div>

                  <div className="mb-4">
                    <label className="form-label">
                      Website link
                    </label>
                    <input
                      type="text"
                      className="form-control custom-input"
                    />
                  </div>

                  <div className="mb-4">
                    <label className="form-label">
                      How Can We Help You?<span>*</span>
                    </label>
                    <textarea
                      rows="6"
                      className="form-control custom-input"
                    ></textarea>
                  </div>

                  <button type="submit" className="send-btn">
                    Send Message
                  </button>

                </form>
              </div>

            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default ContactUs
